module.exports = __webpack_public_path__ + "static/media/ChrisLewis.9f1a172e.jpg";